import { useMemo } from 'react';
import { useSchema } from '../../../hooks/use-schema';
import { mapFilmListToItemListSchema } from '../../../utils/schema-mappers/film-list';
export const useFilmListSchema = (config, films, i18n, filmUrlFactory) => {
    const schema = useMemo(() => {
        if (!config.enable || films.length === 0)
            return undefined;
        return mapFilmListToItemListSchema(films, i18n, filmUrlFactory);
    }, [config, films, filmUrlFactory, i18n]);
    useSchema(schema);
};
